export const ProductRecommendations = "d2b5f5b5202d46f299889ed0343804a93eefda8e335b6789982410fc48274c69";